// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-4330e724],select[data-v-4330e724],textarea[data-v-4330e724]{font-size:16px}}.ps-product--full-content .ps-product__price-right .ps-product__actions a .red[data-v-4330e724]{color:red}@media(max-width:767px){.ps-product--detail[data-v-4330e724]{margin-bottom:15px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
